var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"devices-container d-flex flex-column"},[_c('DeviceCommand',{ref:"command-modal"}),_c('DeviceSettings',{ref:"settings-modal"}),_vm._l((_vm.deviceInfo),function(device){return _c('ItemDevice',{key:device?.id,attrs:{"device":device},on:{"command":_vm.openCommands,"settings":_vm.openSettings}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }